import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import RPT from 'prop-types';

var LoadScript = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadScript, _React$Component);

  var _super = _createSuper(LoadScript);

  function LoadScript(props) {
    var _this;

    _classCallCheck(this, LoadScript);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "scriptLoaderId", '');

    _this.scriptLoaderId = "id".concat(LoadScript.idCount++); // eslint-disable-line space-unary-ops, no-plusplus

    return _this;
  }

  _createClass(LoadScript, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          onError = _this$props.onError,
          onLoad = _this$props.onLoad,
          url = _this$props.url;

      if (LoadScript.loadedScripts[url]) {
        onLoad();
        return;
      }

      if (LoadScript.erroredScripts[url]) {
        onError();
        return;
      }

      if (LoadScript.scriptObservers[url]) {
        LoadScript.scriptObservers[url][this.scriptLoaderId] = this.props;
        return;
      }

      LoadScript.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);
      this.createScript();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var url = this.props.url;
      var observers = LoadScript.scriptObservers[url];

      if (observers) {
        delete observers[this.scriptLoaderId];
      }
    }
  }, {
    key: "createScript",
    value: function createScript() {
      var _this2 = this;

      var _this$props2 = this.props,
          onCreate = _this$props2.onCreate,
          url = _this$props2.url,
          attributes = _this$props2.attributes;
      var script = document.createElement('script');
      onCreate();

      if (attributes) {
        Object.keys(attributes).forEach(function (prop) {
          script.setAttribute(prop, attributes[prop]);
        });
      }

      script.src = url;

      if (!script.hasAttribute('async')) {
        script.async = true;
      }

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
        var observers = LoadScript.scriptObservers[url];
        Object.keys(observers).forEach(function (key) {
          if (shouldRemoveObserver(observers[key])) {
            delete LoadScript.scriptObservers[url][_this2.scriptLoaderId];
          }
        });
      };

      script.onload = function () {
        LoadScript.loadedScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onLoad();
          return true;
        });
      };

      script.onerror = function () {
        LoadScript.erroredScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onError();
          return true;
        });
      };

      document.body.appendChild(script);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return LoadScript;
}(React.Component);

_defineProperty(LoadScript, "propTypes", {
  attributes: RPT.object,
  onCreate: RPT.func,
  onError: RPT.func.isRequired,
  onLoad: RPT.func.isRequired,
  url: RPT.string.isRequired
});

_defineProperty(LoadScript, "defaultProps", {
  onCreate: function onCreate() {},
  onError: function onError() {},
  onLoad: function onLoad() {}
});

_defineProperty(LoadScript, "scriptObservers", {});

_defineProperty(LoadScript, "loadedScripts", {});

_defineProperty(LoadScript, "erroredScripts", {});

_defineProperty(LoadScript, "idCount", 0);

export default LoadScript;